import React, {isValidElement, useEffect, useState} from 'react';
import {ToastContainer} from 'react-toastify';
import AppLoader from '../../HelperClasses/AppLoaderClasses/AppLoader';
import HeaderView from '../../Settings/HeaderView';
import ToastPopup from '../../HelperClasses/AppLoaderClasses/ToastPopup';
import {getAllUsers} from '../../Actions/getUsers';
import SelectDropDown from '../../UI/Form/SelectDropDown';
import TextInput from '../../UI/Form/TextInput';
import {onUserSubmit} from './actions/OnUserSubmit';
import colors from '../../HelperClasses/AppColor';
import SelectSearchView from 'react-select';
import {getAllAccounts} from '../../Actions/getAccount';

const SetupAccount = ({onCloseModal, onSelectAccount, selectedAccount}) => {
  const [isLoading, setIsLoading] = useState(false);

  const [accounts, setAccounts] = useState([]);

  useEffect(() => {
    getAllAccounts({}).then(res => {
      setAccounts(res);
    });
  }, []);

  return (
    <div className="  w-full h-full pt-2  ">
      <SelectSearchView
        value={
          selectedAccount
            ? {
                label: selectedAccount?.name,
                value: selectedAccount?.id,
              }
            : null
        }
        onChange={itm => {
          const selected_account = accounts?.find(c => c.id === itm.value);
          onSelectAccount(selected_account);
        }}
        options={accounts?.map(c => ({
          label: c.name,
          value: c.id,
        }))}
        isMulti={false}
        placeholder={`Select Account`}
      />

      <AppLoader enable={!isLoading} />
    </div>
  );
};

export default SetupAccount;

// const colourStyles = {
//   control: styles => ({...styles, backgroundColor: 'white', borderRadius: 5}),
//   option: (styles, {data, isDisabled, isFocused, isSelected}) => {
//     // const color = chroma(data.color);
//     return {
//       ...styles,
//       backgroundColor: isDisabled
//         ? null
//         : isSelected
//         ? data.color
//         : isFocused
//         ? colors.SimonGray
//         : null,
//       color: isDisabled
//         ? '#ccc'
//         : isSelected
//         ? colors.SimonGray
//           ? colors.AppRed
//           : 'black'
//         : data.color,
//       cursor: isDisabled ? 'not-allowed' : 'default',
//       ':active': {
//         ...styles[':active'],
//         backgroundColor:
//           !isDisabled && (isSelected ? data.color : colors.Lightgray),
//       },
//     };
//   },
//   multiValueLabel: (styles, {data}) => ({
//     ...styles,
//     color: data.color,
//   }),
//   multiValueRemove: (styles, {data}) => ({
//     ...styles,
//     color: data.color,
//     ':hover': {
//       backgroundColor: data.color,
//       color: colors.AppRed,
//     },
//   }),
// };
